import { useLocation, useNavigate } from 'react-router-dom'

import { Box, Tabs } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

type Props = {
  legalEntityId: number
  canSeeEmployees?: boolean
}

const LegalEntityTabs = ({
  children,
  legalEntityId,
  canSeeEmployees,
}: React.PropsWithChildren<Props>) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { navigation } = useNavigation()
  const { featureAvailability } = useFeatureAvailability(Features.time_balance_annualisation_export)
  const canSeeTimeConditions = featureAvailability?.available

  return (
    <Box width="full">
      <Tabs currentId={pathname} onTabClicked={(tabId) => navigate(tabId)} hasAdditionalPadding>
        <Tabs.Tab
          id={navigation.settings.legalEntitiesId.details.fullPath({ id: legalEntityId })}
          label={i18n.t('settings.legal_entities.legal_entity.navigation.details')}
        />
        {!canSeeEmployees ? (
          <></>
        ) : (
          <Tabs.Tab
            id={navigation.settings.legalEntitiesId.employeeGroups.fullPath({ id: legalEntityId })}
            label={i18n.t('settings.legal_entities.legal_entity.navigation.employees')}
          />
        )}
        <Tabs.Tab
          id={navigation.settings.legalEntitiesId.contracts.fullPath({ id: legalEntityId })}
          label={i18n.t('settings.legal_entities.legal_entity.navigation.contracts')}
        />
        {!canSeeTimeConditions ? (
          <></>
        ) : (
          <Tabs.Tab
            id={navigation.settings.legalEntitiesId.timeConditions.fullPath({ id: legalEntityId })}
            label={i18n.t('settings.legal_entities.legal_entity.navigation.time_conditions')}
          />
        )}
      </Tabs>
      <Box paddingTop="s24" alignItems="center">
        {children}
      </Box>
    </Box>
  )
}

export default LegalEntityTabs
